import readerConfigurations from 'collections/newsroom/configurationsInstance';
import fetchOncePromise from 'libraries/fetchOncePromise';

export default fetchOncePromise(readerConfigurations);
